import Box from "@/components/Box";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";

import {
  dashboardHeaderRowGap,
  dashboardPanelPadding,
  dashboardPanelTitleContentGap,
  dashboardSectionTitle
} from "./learningHub/dashboardLayout";

export default function DashboardPanel({
  title,
  bg = "white",
  titleColor,
  padding,
  headerStart,
  headerStartGap = dashboardHeaderRowGap,
  headerEnd,
  headerWrap = false,
  titleProps,
  contentScrollProps,
  fillHeight = false,
  footer,
  footerStackPb,
  children
}) {
  const resolvedPadding = padding ?? dashboardPanelPadding;
  const { px: panelPx, pt: panelPt, pb: panelPb } = resolvedPadding;

  const {
    maxHeight: contentMaxHeight,
    minHeight: contentMinHeight,
    px: scrollContentPx,
    pl: scrollPlProp,
    pr: scrollPrProp,
    ...contentScrollBodyProps
  } = contentScrollProps ?? {};

  const scrollPl = scrollPlProp ?? scrollContentPx ?? panelPx;
  const scrollPr = scrollPrProp ?? scrollContentPx ?? panelPx;

  const scrollBodyProps = {
    width: "100%",
    minWidth: 0,
    pl: scrollPl,
    pr: scrollPr,
    ...contentScrollBodyProps,
    ...(contentMaxHeight != null && !fillHeight ? { maxHeight: contentMaxHeight } : {}),
    minHeight: fillHeight ? 0 : contentMinHeight,
    overflowY: "auto",
    overflowX: "hidden"
  };

  const content = contentScrollProps ? (
    fillHeight ? (
      <Box {...scrollBodyProps}>{children}</Box>
    ) : (
      <Box {...scrollBodyProps} flex="1 1 0%">
        {children}
      </Box>
    )
  ) : (
    children
  );

  const stackPadding = contentScrollProps
    ? { pt: panelPt, pb: footer ? footerStackPb ?? 0 : panelPb, px: 0 }
    : footer
    ? { ...resolvedPadding, pb: footerStackPb ?? 0 }
    : resolvedPadding;

  const panelLayoutProps = fillHeight
    ? {
        display: "grid",
        gridTemplateRows: "auto minmax(0, 1fr)",
        rowGap: dashboardPanelTitleContentGap,
        height: "100%",
        flex: "1 1 0%",
        minHeight: 0,
        overflow: "hidden",
        alignSelf: "stretch"
      }
    : {
        gap: dashboardPanelTitleContentGap,
        height: contentScrollProps ? "auto" : "fit-content",
        overflow: contentMaxHeight ? "hidden" : undefined,
        alignSelf: "start",
        alignItems: "flex-start"
      };

  return (
    <Stack bg={bg} borderRadius={20} {...stackPadding} width="100%" {...panelLayoutProps}>
      <Group
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        flexWrap={headerWrap ? "wrap" : undefined}
        rowGap={headerWrap ? dashboardHeaderRowGap : undefined}
        gap={dashboardHeaderRowGap}
        flexShrink={0}
        px={contentScrollProps ? panelPx : undefined}
      >
        <Group
          alignItems="center"
          gap={headerStartGap}
          flex={headerWrap ? "1 1 auto" : "1"}
          minWidth={headerWrap ? "min-content" : 0}
        >
          {headerStart}
          <Box
            {...dashboardSectionTitle}
            {...titleProps}
            color={titleColor}
            minWidth={headerWrap ? 0 : undefined}
            flex={headerWrap ? "1 1 auto" : undefined}
          >
            {title}
          </Box>
        </Group>
        {headerEnd}
      </Group>
      {content}
      {footer}
    </Stack>
  );
}
